// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {
  $(document).ready(function () {
    // Main Nav Dropdown
    $("#primary-nav li").hover(
      function () {
        $(this).addClass("hover");
        $("ul.submenu", this).fadeIn(200);
      },
      function () {
        $(this).removeClass("hover");
        $("ul.submenu", this).fadeOut(200);
      }
    );

    //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
    let DATE_STYLE = [true];
    function calendarRange(date) {
      let d1 = $.datepicker.parseDate(DATE_FORMAT, $("#CheckIn").val());
      let d2 = $.datepicker.parseDate(DATE_FORMAT, $("#CheckOut").val());
      if (
        (d1 && date.getTime() == d1.getTime()) ||
        (d2 && date.getTime() == d2.getTime())
      ) {
        DATE_STYLE[1] = "highlight-top";
      } else if (date > d1 && date < d2) {
        DATE_STYLE[1] = "highlight";
      } else {
        DATE_STYLE[1] = "";
      }
      return DATE_STYLE;
    }

    //Check in and check out datepicker for booking engine
    const DATE_FORMAT =
      $("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")
        ? $("#CheckIn").data("format")
        : "yy-mm-dd";
    $("#CheckIn").datepicker({
      changeMonth: true,
      dateFormat: DATE_FORMAT,
      numberOfMonths: 1,
      minDate: 0,
      beforeShowDay: (date) => calendarRange(date),
      onSelect: function (selectedDate) {
        let getDate = $(this).datepicker("getDate");
        let newDate = new Date(getDate.getTime());
        newDate.setDate(newDate.getDate() + 3);
        $("#CheckOut").datepicker("setDate", newDate);
        $("#CheckOut").datepicker("option", "minDate", selectedDate);
      },
    });
    $("#CheckOut").datepicker({
      dateFormat: DATE_FORMAT,
      changeMonth: true,
      numberOfMonths: 1,
      beforeShowDay: (date) => calendarRange(date),
    });
  });

  window.onload = function () {
    scrollW();
    window.addEventListener("scroll", function () {
      scrollW();
      changeHeaderLogo();
    });
  };
})();

function scrollW() {
  //check scroll down or up for header styles
  let st = window.pageYOffset || document.documentElement.scrollTop;
  if (st > 80) {
    if (st > lastScrollTop) {
      // downscroll code
      if (!document.getElementById("header").classList.contains("down")) {
        document.getElementById("header").classList.add("down");
        document.getElementById("header").classList.remove("up");

        document.getElementById("hotel-back").classList.add("down")
        document.getElementById("hotel-back").classList.remove("up")
      }
    } else {
      // upscroll code
      if (!document.getElementById("header").classList.contains("up")) {
        document.getElementById("header").classList.add("up");
        document.getElementById("header").classList.remove("down");

        document.getElementById("hotel-back").classList.add("up")
        document.getElementById("hotel-back").classList.remove("down")
      }
    }
  } else {
    if (
      document.getElementById("header").classList.contains("up") ||
      document.getElementById("header").classList.contains("down")
    ) {
      document.getElementById("header").classList.remove("up");
      document.getElementById("header").classList.remove("down");
      
      document.getElementById("hotel-back").classList.remove("up")
      document.getElementById("hotel-back").classList.remove("down")
    }
  }
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function changeHeaderLogo() {
  let logo = "/assets/svg/Logo.svg";
  let white_logo = "/assets/svg/white-logo-header.svg";
  let header = document.getElementById("header");

  let current_logo = document.querySelector(".header__logo img");
  // let lastImage = current_logo.src;

  if (header.classList.contains("down") || header.classList.contains("up")) {
    current_logo.src = white_logo;
  } else {
    current_logo.src = logo;
  }
}

function showMenus(identifier) {
  let menus = document.querySelectorAll(".menu-info");
  menus.forEach((menu) => {
    if (menu.classList.contains(identifier)) {
      menu.classList.add("active");
    } else {
      menu.classList.remove("active");
    }
  });
}

// Menus Filter
for (let i = 0; i < document.querySelectorAll(".menuButton").length; i++) {
  document.querySelectorAll(".menuButton")[0].classList.add("active");
  document.querySelectorAll(".menu-info")[0].classList.add("active");
}

document.querySelectorAll(".menuButton").forEach((button) => {
  button.addEventListener("click", function () {
    // remove active class for all buttons
    let buttons = document.querySelectorAll(".menuButton");
    buttons.forEach((button) => {
      button.classList.remove("active");
    });
    this.classList.toggle("active"); // -> Add active class

    showMenus(this.id);
  });
});

// Burger Menu
if (document.getElementById("burger-box__menu")) {
  let burgerMenu = document.getElementById("burger-box__menu");
  let navigation = document.querySelector(".header-right");
  let burgerMenu_message = document.querySelector("#burge-box__menu .text");

  const LOGO = "/assets/svg/Logo.svg";
  const WHITE_LOGO = "/assets/svg/white-logo-header.svg";

  const CURRENT_LOGO = document.querySelector(".header__logo img");
  const HEADER = document.getElementById("header");

  burgerMenu.addEventListener("click", () => {
    navigation.classList.toggle("active");
    burgerMenu.classList.toggle("active");
    //This conditional makes the logo change to white or return to its original color every time the hamburger menu is clicked, considering the navigation state.
    if (
      navigation.classList.contains("active") &&
      (!HEADER.classList.contains("down") || !HEADER.classList.contains("up"))
    ) {
      CURRENT_LOGO.src = WHITE_LOGO;
      burgerMenu_message.textContent = "Close";
    } else if (
      navigation.classList.contains("active") &&
      (HEADER.classList.contains("down") || HEADER.classList.contains("up"))
    ) {
      CURRENT_LOGO.src = WHITE_LOGO;
      burgerMenu_message.textContent = "Close";
    } else if (
      !navigation.classList.contains("active") &&
      (HEADER.classList.contains("down") || HEADER.classList.contains("up"))
    ) {
      CURRENT_LOGO.src = WHITE_LOGO;
      burgerMenu_message.textContent = "Menu";
    } else {
      CURRENT_LOGO.src = LOGO;
      burgerMenu_message.textContent = "Menu";
    }
  });
}


